import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import StickyBookNow from './Components/BoookAppointment/StickyBookNow';
import WhatsAppPopup from './Components/WhatsAppPopup/WhatsAppPopup';
import { useLocation } from 'react-router-dom';
import OpeningCeremony from './Components/Blogs/openingCeremony/openingCeremony.jsx';
import Blogs from './Components/Blogs/Blogs.js';
import BlogDetail from './Components/Blogs/BlogDetail.js';
// Pages
import Home from './Components/Home/Home';
import About from './Components/AboutUs/About';
import Contact from './Components/Contact/Contact';
import BookAppointment from './Components/BoookAppointment/BookAppointment';
import Doctors from './Components/AboutUs/Doctors.jsx';
// Services (dynamic, DB-driven)
import ServiceDetail from './Components/Service/ServiceDetail';
import Career from './Components/Career/Career.js';

import ScrollToTop from './Components/ScrolltoTop.js';
import AdminApp from './admin/AdminApp';
import { SiteSettingsProvider } from './SiteSettings';

function PublicChrome({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  if (isAdmin) {
    return <>{children}</>;
  }
  return (
    <>
      <StickyBookNow />
      <Header />
      {children}
      <Footer />
      <WhatsAppPopup />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>

      {/* ✅ GLOBAL SEO (VERY IMPORTANT) */}
      <Helmet>
        <html lang="en" />

        <meta charSet="utf-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta name="robots" content="index, follow" />

        <meta name="author" content="Amaanat IVF Clinic" />

        {/* Google Verification (ADD YOUR CODE LATER) */}
        {/* <meta name="google-site-verification" content="XXXX" /> */}

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalOrganization",
            "name": "Amaanat IVF Clinic",
            "url": "https://amaanativf.com",
            "logo": "https://amaanativf.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9991641100",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": "English"
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            },
            "sameAs": [
              "https://www.facebook.com/",
              "https://www.instagram.com/"
            ]
          })}
        </script>
      </Helmet>

      <ScrollToTop />
      <SiteSettingsProvider>
      <PublicChrome>
        <Routes>
          {/* ADMIN PANEL (no public header/footer) */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* PUBLIC PAGES */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/bookappointment" element={<BookAppointment />} />
          <Route path='Doctors' element={<Doctors />} />
          {/* SERVICES (dynamic, DB-driven — slug routes plus legacy aliases) */}
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/openingCeremony" element={<OpeningCeremony />} />

          {/* BLOGS (dynamic) */}
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />

          {/* CAREER */}
          <Route path="/career" element={<Career />} />

          {/* ✅ SEO IMPORTANT: 404 PAGE */}
          <Route path="*" element={
            <div style={{ padding: "100px", textAlign: "center" }}>
              <h1>404 - Page Not Found</h1>
              <p>This page does not exist.</p>
            </div>
          } />
        </Routes>
      </PublicChrome>
      </SiteSettingsProvider>

    </BrowserRouter>
  );
}

export default App;